import { C6_PRODUCT_CARD_CHOICE } from '../cross-selling-modal/cross-selling-products-layout';

/** Two equal columns; a third horizontal C6 card wraps onto the next row. */
const C6_TWO_COLUMNS = 'repeat(2, minmax(0, 1fr))';

/** One track, capped so a lone card stays a card and can be centered. */
const C6_SINGLE_COLUMN = 'minmax(0, 365px)';

export interface UpsellingProductsLayout {
  gridTemplateColumns: string;
  centerSingleCard: boolean;
  /** Desktop modal grows so two horizontal C6 cards keep a readable text column. */
  wideModal: boolean;
}

export function resolveUpsellingProductsLayout(input: {
  productCount: number;
  productCardChoice: number | string | null | undefined;
  productCardColSpan: number | null | undefined;
  showsKioskProductCard: boolean;
}): UpsellingProductsLayout {
  const isC6Layout =
    Number(input.productCardChoice) === C6_PRODUCT_CARD_CHOICE && input.showsKioskProductCard;

  if (isC6Layout) {
    if (input.productCount <= 1) {
      return {
        gridTemplateColumns: C6_SINGLE_COLUMN,
        centerSingleCard: true,
        wideModal: false,
      };
    }

    return {
      gridTemplateColumns: C6_TWO_COLUMNS,
      centerSingleCard: false,
      wideModal: true,
    };
  }

  const columns = input.productCount < 3 || input.productCardColSpan === 2 ? 2 : 3;

  return {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    centerSingleCard: false,
    wideModal: false,
  };
}
